import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ReportRowData, ComparedActivityReportSummary} from 'nutshell-core/types';

import type {ActivityReportPjaxResponseType} from '../report-types';

import * as actions from './activity-report-actions';

type State = {
    data: string | null | undefined;
    hasError: boolean;
    isLoading: boolean;
    numPages: number | null | undefined;
};
const defaultState = {
    data: null,
    hasError: false,
    isLoading: true,
    numPages: null,
} as const;

type SummaryState = {
    hasError: boolean;
    isLoading: boolean;
    data: ComparedActivityReportSummary<Array<ReportRowData>> | null | undefined;
    totals: ComparedActivityReportSummary<ReportRowData> | null | undefined;
};
const defaultSummaryState = {
    ...defaultState,
    totals: null,
} as const;

export const activitiesReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestActivityReportActivities]: (state) => {
            return {...state, isLoading: true, hasError: false};
        },
        [actions.updateActivityReportActivities]: (
            // @ts-expect-error
            state,
            response: ActivityReportPjaxResponseType
        ) => {
            return {
                ...state,
                data: response.table,
                numPages: response.numPages,
                isLoading: false,
                hasError: false,
            };
        },
        // @ts-expect-error
        [actions.failActivityReportActivities]: (state) => {
            return {...state, isLoading: false, hasError: true};
        },
    },
    defaultState
);

export const summaryReducer = (
    state: SummaryState | null | undefined = defaultSummaryState,
    action: actions.ActivityReportAction
): SummaryState => {
    switch (action.type) {
        case actions.ActionTypes.ACTIVITY_REPORT_FETCH_SUMMARY_REQUEST:
            // @ts-expect-error
            return {...state, isLoading: true};
        case actions.ActionTypes.ACTIVITY_REPORT_FETCH_SUMMARY_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                totals: action.payload.totals,
                isLoading: false,
                hasError: false,
            };
        case actions.ActionTypes.ACTIVITY_REPORT_FETCH_SUMMARY_FAILURE:
            // @ts-expect-error
            return {...state, isLoading: false, hasError: true};
        default:
            // @ts-expect-error
            return state;
    }
};

type LeadOutcomesState =
    | {
          lostOrCancelled: number;
          won: number;
          unknown: number;
      }
    | null
    | undefined;

// TODO: clean up action type
export const leadOutcomesReducer = (
    state: LeadOutcomesState | null | undefined = null,
    action: {
        type: string;
        payload: any;
    }
): LeadOutcomesState => {
    switch (action.type) {
        case 'REPORT_ACTIVITY_SUMMARY_STATS_UPDATED':
            return action.payload.leadOutcomes;
        case 'REPORTS_LEADS_REPORT_DATA_REQUESTED':
            return null;
        default:
            return state;
    }
};

export const activityReportReducer = combineReducers({
    activities: activitiesReducer,
    summary: summaryReducer,
    leadOutcomes: leadOutcomesReducer,
});

export type ActivityReportState = {
    detail: State;
    activities: State;
    summary: SummaryState;
    leadOutcomes: LeadOutcomesState;
};
